export default {
  title: 'Miksi luoda tämä kuva uudelleen?',
  description: 'Auta meitä parantamaan tekoälyä kertomalla, mikä oli pielessä.',
  reasons: {
    wrong_style: 'Väärä tyyli',
    wrong_colors: 'Väärät värit',
    wrong_food_item: 'Väärä ruoka-annos',
    low_quality: 'Huono laatu',
    doesnt_match_brand: 'Ei vastaa brändiäni',
    text_issues: 'Teksti tai merkinnät ovat väärin',
    other: 'Muu',
  },
  details_label: 'Jotain muuta? (valinnainen)',
  details_placeholder: 'Lisää tarkempia tietoja, jotta ymmärrämme paremmin…',
  cancel: 'Peruuta',
  confirm: 'Luo uudelleen',
};
